import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelPlansEditDetailsResolverErrorStatesEnum {
    GetPlanFailed = ErrorStateScheduleEnum.PanelPlansEditDetailsResolverErrorStatesStartIndex,
    GetParentResolverDataFailed,
    GetTradingPlatformsFailed,
    GetPlanTypesFailed,
    GetPlanStatusesFailed,
    GetPlanAvailableTriggersFailed,
    GetPrizeGroupsFailed
}